export enum TemperatureKey {
    T20 = "T20",
    T25 = "T25",
}

export type Temperature = {
    key: TemperatureKey;
    value: number;
    unit: string;
};
